// this file added by Bearer Web Developer
import React from "react";
import styles from './loading.module.scss';

const Loading: React.FC = () => {
    return (
        <div className={styles?.loading}>
            <img src="/bearer-individual-logo-with-background.png" alt="" width="294" height="113" />
            <img src="/animate-loading.svg" alt="" width="388" height="70" />
        </div>
    )
}
export default Loading;